import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ParamsMedia, FilterMedia } from '../models';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-media-v2',
  templateUrl: './media_v2.component.html',
  styleUrls: ['./media_v2.component.css'],
})

export class MediaV2Component implements OnInit {
  public medias: Array<ParamsMedia>;
  public updateMedia: ParamsMedia = new ParamsMedia;
  public detectChangeNewMedia: any = new ParamsMedia;

  @Output() media: EventEmitter<ParamsMedia> = new EventEmitter<ParamsMedia>();

  // tslint:disable-next-line:no-input-rename
  @Input('filter') filter: FilterMedia;
  // tslint:disable-next-line:no-input-rename
  @Input('restrictedTo') restrictedTo: FilterMedia;

  ngOnInit(): void {
    this.medias = new Array<ParamsMedia>();
    this.restrictedTo = this.restrictedTo ? this.restrictedTo : new FilterMedia;
    this.filter = this.filter ? this.filter : new FilterMedia;
  }

  public changeUpdateMedia(media: ParamsMedia): void {
    this.updateMedia = media;
  }
  public selectMedia(media: ParamsMedia): void {
    // Access to XMLHttpRequest from origin 'http://localhost' has been blocked by CORS policy: No 'Access-Control-Allow-Origin' header is present on the requested resource.

    //const http: XMLHttpRequest = new XMLHttpRequest();
    //http.onload = (): void => {
    //  try {
    //    // http.send();
    //    if (http.status !== 404) {
    //      media.Exist = true;
    //    } else {
    //      media.Exist = false;
    //    }

    //  } catch {
    //    media.Exist = false;
    //  }
      this.media.emit(JSON.parse(JSON.stringify(media)));
    //};
    //http.open('HEAD', media.Path, true);
    //http.send(null);

  }

  addMedia(media: ParamsMedia): void {
    this.detectChangeNewMedia = JSON.parse(JSON.stringify(media));

    // Access to XMLHttpRequest from origin 'http://localhost' has been blocked by CORS policy: No 'Access-Control-Allow-Origin' header is present on the requested resource.

    //const http: XMLHttpRequest = new XMLHttpRequest();
    //http.onload = (): void => {
    //  try {
    //    // http.send();
    //    if (http.status !== 404) {
    //      media.Exist = true;
    //    } else {
    //      media.Exist = false;
    //    }
    //  } catch {
    //    media.Exist = false;
    //  }
      this.media.emit(JSON.parse(JSON.stringify(media)));
    //};
    //http.open('HEAD', media.Path, true);
    //http.send(null);
  }
}
